import { render, staticRenderFns } from "./OPOListCard.vue?vue&type=template&id=101d2e83"
import script from "./OPOListCard.vue?vue&type=script&lang=js"
export * from "./OPOListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports